<template>
    <div :class="cardClass">
        <div class="external-recipient-card__body">
            <p class="external-recipient-card__name">{{ displayName }}</p>
            <span class="external-recipient-card__category">{{ categoryLabel }}</span>
            <p class="external-recipient-card__status">{{ outreachLabel }}</p>
            <p v-if="errorOrReasonCode" class="external-recipient-card__error">{{ errorOrReasonCode }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            recipient: {
                type: Object,
                required: true,
            },
        },

        computed: {
            cardClass() {
                return {
                    card: true,
                    'card__fixed-hight': true,
                    'card--is-standalone': true,
                    'external-recipient-card': true,
                }
            },
            displayName() {
                const contact = this.recipient.data && this.recipient.data.contactInfo
                if (contact && (contact.firstName || contact.lastName)) {
                    return [contact.firstName, contact.lastName].filter(Boolean).join(' ').trim()
                }
                return this.recipient.providerNpi ? `NPI ${this.recipient.providerNpi}` : 'Provider'
            },
            isConstrained() {
                return !!(this.recipient.data && this.recipient.data.constrained)
            },
            categoryLabel() {
                return this.isConstrained ? 'Constrained' : 'Not matched'
            },
            outreachLabel() {
                const data = this.recipient.data || {}
                const outreachSent = !!data.outreachSentAt

                if (this.recipient.status === 'CLAIMED') return 'Joined'
                if (this.recipient.status === 'FAILED') return 'Outreach failed'
                if (this.recipient.status === 'NO_CONTACT') return 'No contact info'

                if (this.isConstrained) {
                    return outreachSent ? 'Email sent' : 'Email pending'
                }
                return outreachSent ? 'Invite sent' : 'Invite pending'
            },
            errorOrReasonCode() {
                const data = this.recipient.data || {}
                return data.reasonCode || null
            },
        },
    }
</script>

<style scoped lang="scss">
    .external-recipient-card {
        min-height: 120px;

        &__body {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 20px;
            text-align: center;
        }

        &__name {
            font-weight: 500;
            color: #333;
            margin: 0 0 4px;
            font-size: 16px;
        }

        &__category {
            display: inline-block;
            font-size: 11px;
            font-weight: 600;
            color: #555;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 4px;
        }

        &__status {
            font-size: 14px;
            color: #666;
            margin: 0;
        }

        &__error {
            font-size: 12px;
            color: #888;
            margin: 4px 0 0;
            max-width: 260px;
            word-break: break-word;
        }
    }
</style>
